import PropTypes from 'prop-types'

const jobExecutionType = PropTypes.shape({
    id: PropTypes.number, // id du job
    name: PropTypes.string,
    jobType: PropTypes.string,
    cron: PropTypes.string,
    lastExecution: PropTypes.number,
    status: PropTypes.number,
    duration: PropTypes.number,
})

const jobSupervisionType = PropTypes.shape({
    countJobs: PropTypes.number,
    notLaunchedJobs: PropTypes.arrayOf(jobExecutionType),
    errorJobs: PropTypes.arrayOf(jobExecutionType),
    tooLongJobs: PropTypes.arrayOf(jobExecutionType),
    fullDirectories: PropTypes.arrayOf(PropTypes.shape({
        path: PropTypes.string,
        count: PropTypes.number,
    })),
})

export { jobSupervisionType }